import BaseModal from "@/components/base/modal/BaseModal";
import IconDonLinear from "@/assets/icons/don-linear.svg?react";
import IconAdCircleOnLinear from "@/assets/icons/ad-circle-on-linear.svg?react";
import IconCoinsLinear from "@/assets/icons/coins-linear.svg?react";
import IconRocketLinear from "@/assets/icons/rocket-linear.svg?react";
import { useTranslation } from "react-i18next";
import BaseButton from "@/components/base/button/BaseButton.tsx";
import { useNavigate } from "react-router";
import { Fragment } from "react/jsx-runtime";
import { usePremiumInfos } from "@/pages/profile/api";
import { formatNumber } from "@/shared/utils";

interface Props {
  open: boolean;
  onClose?: () => void;
}

export default function ModalBuyPremium({ open, onClose }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: premium } = usePremiumInfos();

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      image="images/patterns/buy-premium-modal.webp"
    >
      <div>
        <h2 className="text-center text-[30px] bg-yellow-linear bg-clip-text text-transparent leading-130 font-extrabold uppercase self-stretch mb-1">
          Premium
        </h2>
        <p className="text-center px-2 text-white/80 font-normal leading-130 text-xs mb-4">
          {t("modal_premium_description")}
        </p>
        <div className="flex bg-white/08 border-b border-white/08 rounded-2xl pl-3 flex-col overflow-hidden">
          <Fragment>
            <div
              key="0"
              className="flex items-center justify-start gap-2 py-2 relative group"
            >
              <IconDonLinear width="24" height="24" />
              <div className="text-xs font-semibold leading-130 w-full pr-3">
                {t("double_don")}
              </div>
              <hr className="border-none h-px w-full bg-white/08 absolute bottom-0 left-8" />
            </div>
          </Fragment>

          <Fragment>
            <div
              key="2"
              className="flex items-center justify-start gap-2 py-2 relative group"
            >
              <IconCoinsLinear width="24" height="24" />
              <div className="text-xs font-semibold leading-130 w-full pr-3">
                {t("bonus_don", {
                  value: formatNumber(premium?.[0].don_award ?? 25000),
                })}
              </div>
              <hr className="border-none h-px w-full bg-white/08 absolute bottom-0 left-8" />
            </div>
          </Fragment>

          <Fragment>
            <div
              key="1"
              className="flex items-center justify-start gap-2 py-2 relative group"
            >
              <IconAdCircleOnLinear width="24" height="24" />
              <div className="text-xs font-semibold leading-130 w-full pr-3">
                {t("see_more_ads_and_get_more_don")}
              </div>
              <hr className="border-none h-px w-full bg-white/08 absolute bottom-0 left-8" />
            </div>
          </Fragment>

          <Fragment>
            <div
              key="3"
              className="flex items-center justify-start gap-2 py-2 relative group"
            >
              <IconRocketLinear width="24" height="24" />
              <div className="text-xs font-semibold leading-130 w-full pr-3">
                {t("unlimited_challenges")}
              </div>
              {/* No hr for the last item due to group-last:hidden */}
            </div>
          </Fragment>
        </div>
        <BaseButton
          className="w-full !text-dark mt-4"
          text={t("go_to_premium")}
          variant="premium"
          onClick={() => {
            onClose?.();
            navigate("/profile/premium");
          }}
        />
      </div>
    </BaseModal>
  );
}
